import Icon from '@ant-design/icons';
import type { CustomIconComponentProps, IconComponentProps } from '@ant-design/icons/lib/components/Icon';

type IconProps = Pick<IconComponentProps, 'onClick'>;

const InfoIconSvg = ({ fill = '#808CB2' }: { fill: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path
            d="M6.99966 4.33333C6.90766 4.33333 6.83299 4.408 6.83366 4.5C6.83366 4.592 6.90833 4.66667 7.00033 4.66667C7.09233 4.66667 7.16699 4.592 7.16699 4.5C7.16699 4.408 7.09233 4.33333 6.99966 4.33333"
            stroke={fill}
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7 13V13C3.686 13 1 10.314 1 7V7C1 3.686 3.686 1 7 1V1C10.314 1 13 3.686 13 7V7C13 10.314 10.314 13 7 13Z"
            stroke={fill}
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path d="M7.00033 7V10.3333" stroke={fill} stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

const InfoIcon = (props: Partial<CustomIconComponentProps & IconProps>) => (
    <Icon component={() => <InfoIconSvg fill={props.fill || 'currentColor'} />} {...props} />
);

export default InfoIcon;
